import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapActions } from 'vuex';
export default {
  components: {},
  mixins: [],
  data: function data() {
    return {
      tableData: [],
      statusList: [{
        lable: '正常',
        value: 1
      }, {
        lable: '禁用',
        value: 2
      }, {
        lable: '审核中',
        value: 3
      }],
      tips: ''
    };
  },
  computed: _objectSpread({}, mapState('d2admin/user', ['info'])),
  created: function created() {
    if (this.info.is_develop == 1) {
      if (this.info.enterprise.status === 0) {
        this.tips = "你所关联的企业尚未审批通过，请联系商务进行审批。";
      } else {
        this.getList();
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    getList: function getList() {
      var _this = this;

      this.$api.authAppList({
        type: 'my'
      }).then(function (resq) {
        if (resq.status == 200) {
          _this.tableData = resq.data;

          if (!_this.tableData.length) {
            _this.tips = "当前还未开通任何产品权限，请联系商务开通。";
          } else {
            _this.tips = "";
          }
        }
      });
    }
  }
};